// extracted by mini-css-extract-plugin
export default {"title":"iOsIo","separator":"iKM0Y","paragraph":"_12YMj","button":"zb4xL","rightButton":"_1ZmLG zb4xL"};